import { render } from "./index.vue?vue&type=template&id=29765145&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=29765145&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1401392664/src/resources/buyer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29765145"]])

export default __exports__